import { emit as emit$1 } from "@zapier/events-toolkit-browser";
function emit(eventData, eventType) {
  const botPattern = new RegExp(
    [
      "baiduspider",
      "bingbot",
      "bot",
      "crawl",
      "crawler",
      "crawling",
      "datadog",
      "duckduckbot",
      "facebot",
      "googlebot",
      "ia_archiver",
      "oncrawl",
      "slurp",
      "spider",
      "yandexbot",
      "yeti"
    ].join("|"),
    "i"
  );
  if (typeof window !== "undefined" && !botPattern.test(window.navigator.userAgent)) {
    emit$1(eventData, eventType);
  }
}
function emitUserInteractionEvent(payload) {
  emit(
    {
      system_name: "marketing-site-layout",
      option_selected: "",
      ...payload
    },
    "web_analytics.tracking.user_interaction.UserInteractionEvent"
  );
}
function emitLinkClickEvent(event, payload) {
  emitUserInteractionEvent({
    event_action: "click",
    interaction_raw_text: event.currentTarget.ariaLabel ?? event.currentTarget.text,
    destination_href: event.currentTarget.href,
    ...payload
  });
}
function emitComponentLoadEvent(payload) {
  emit(
    {
      system_name: "marketing-site-layout",
      event_action: "load",
      package_name: "@zapier/marketing-site-layout",
      package_version: "3",
      ...payload
    },
    "web_analytics.tracking.package.PackageComponentLoadEvent"
  );
}
function injectExperiment(experiment, payload) {
  return {
    ...payload,
    ...(experiment == null ? void 0 : experiment.name) ? {
      experiment_flag: true,
      experiment_name: `${experiment.name}:${experiment.variant}`
    } : { experiment_flag: false }
  };
}
export {
  emitComponentLoadEvent,
  emitLinkClickEvent,
  emitUserInteractionEvent,
  injectExperiment
};
